/**
 * Today (slice 4b spec §3): the person's own view, live from the hub's
 * `['today']`, and the look that moves its "since".
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "../../app/api";
import type { TodayView } from "../../../worker/today/view";

/** `GET /api/today` as the route returns it: the Worker's own shape. */
export type Today = TodayView;
export type RecentItem = Today["recent"][number];
export type Working = Today["working"][number];
export type RanItem = Today["ran"][number];

export const todayKey = ["today"] as const;

export function useToday() {
  return useQuery({ queryKey: todayKey, queryFn: () => api<Today>("GET", "/api/today") });
}

/** `POST /api/today/seen` (spec §3.2): "since" starts from now next time. */
export function useTodaySeen() {
  return useMutation({ mutationFn: () => api("POST", "/api/today/seen") });
}
